import { render, staticRenderFns } from "./scope91.vue?vue&type=template&id=b8d755c2&scoped=true"
import script from "./scope91.vue?vue&type=script&lang=js"
export * from "./scope91.vue?vue&type=script&lang=js"
import style0 from "./scope91.vue?vue&type=style&index=0&id=b8d755c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d755c2",
  null
  
)

export default component.exports